var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWorkflow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e4fe130c-1194-40d1-b5a4-e2bb47010cb4",
    x1: 2.624,
    y1: 15.969,
    x2: 2.624,
    y2: 11.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76bc2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#81ce31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#86d633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac1aac1d-90a5-47ab-b231-bd8d57cff665",
    x1: 9.026,
    y1: 18,
    x2: 9.026,
    y2: 13.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76bc2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#81ce31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#86d633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb43c81d-62cd-430c-b971-97ce3b11776c",
    x1: 15.376,
    y1: 16.001,
    x2: 15.376,
    y2: 11.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76bc2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#81ce31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#86d633"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MsPortalFx.base.images-46") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aac33089-9c97-4591-a4d0-bf17c24367ba"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.509,7.868H10.052a.293.293,0,0,1-.293-.293V5.491H8.293V7.575A.294.294,0,0,1,8,7.868H2.479a.587.587,0,0,0-.587.587v2.7H3.358v-1.5a.294.294,0,0,1,.294-.293H8.293v3.918H9.759V9.368h4.577a.293.293,0,0,1,.293.293v1.53H16.1V8.455A.587.587,0,0,0,15.509,7.868Z",
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.029,
    width: 5.881,
    height: 5.881,
    rx: 0.532,
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.158,
    y: 1.13,
    width: 3.622,
    height: 3.622,
    rx: 0.328,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.223,
    y: 11.167,
    width: 4.802,
    height: 4.802,
    rx: 0.435,
    fill: "url(#e4fe130c-1194-40d1-b5a4-e2bb47010cb4)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.624,
    y: 13.198,
    width: 4.802,
    height: 4.802,
    rx: 0.435,
    fill: "url(#ac1aac1d-90a5-47ab-b231-bd8d57cff665)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.975,
    y: 11.199,
    width: 4.802,
    height: 4.802,
    rx: 0.435,
    fill: "url(#fb43c81d-62cd-430c-b971-97ce3b11776c)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkflow);
export default __webpack_public_path__ + "static/media/icon-workflow.fc32b2d7fbf08b906a25e1bf0b507e5f.svg";
export { ForwardRef as ReactComponent };